export default "__VITE_ASSET__9c5942db__"